export default __webpack_public_path__ + "locales/tr/FormFillingTipsDialog.json?hash=06cdc08f2de1cf06d1b3e6f336554342";